export default __webpack_public_path__ + "static/media/p-deliveries.5d2c04a2.png";